import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Modal as BootstrapModal,
} from "reactstrap";
import './Modal.css';

import { IconButton } from "stories/components";

export const Modal = ({ 
  title="", 
  isOpen=false, 
  toggleModal, 
  closeModal, 
  buttons,
  showHeader=true,
  headerExtra,
  className,
  classNameBody,
  size,
  backdrop="static", // When backdrop is set to static, the modal will not close when clicking outside it.
  fade=true,
  children, ...rest 

}) => {
  
  const handleClose = () => {
    if (closeModal) {
      closeModal()
    }
    else if (toggleModal) {
      toggleModal()
    }
  }

  useEffect(() => {
    if (isOpen) return undefined;

    const timer = window.setTimeout(() => {
      if (document.querySelector('.modal.show')) return;

      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    }, 200);

    return () => window.clearTimeout(timer);
  }, [isOpen]);
  
  return (
    <BootstrapModal
      className={`modal-dialog-centered ${className ? className : ""} ${size ? size : ""}`}
      isOpen={isOpen}
      toggle={toggleModal}
      backdrop={backdrop}
      fade={false}
      {...rest}
    >
      {showHeader && 
      <div className="modal-header">
        <div className="d-flex align-items-center flex-grow-1 min-width-0 mr-2">
          <h5 className="modal-title mb-0 mr-2" id="exampleModalLabel">
          {title}
          </h5>
          {headerExtra}
        </div>
        <IconButton aria-label="Close" size="lg" onClick={handleClose} iconName="times" data-dismiss="modal" />
      </div>
      }
      <div className={`modal-body pt-0 ${classNameBody ? classNameBody : ""} `}>
      {children}
      </div>
      
      { buttons && (
        <div className="modal-footer">
          <div style={{width:"100%"}} className="d-flex justify-content-between">
            {buttons}
          </div>
        </div>
      )}
    </BootstrapModal>
  )
};

Modal.propTypes = {
  buttons: PropTypes.array,
  className: PropTypes.string,
  closeModal: PropTypes.func,
  isOpen: PropTypes.bool,
  size: PropTypes.oneOf(['modal-sm','modal-lg','modal-xl','modal-xxl' ]),
  headerExtra: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  toggleModal: PropTypes.func,
};

